/* unplugin-vue-components disabled */import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives } from "vue";
import { useScroll } from '@vueuse/core';
import localCache from '@/utils/localCache';
import { vScroll } from '@vueuse/components';
import { ROUTE_NAME } from '@/config/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup: function setup(__props) {
    var el = ref(null);
    var router = useRouter();
    var smooth = ref(false);
    var behavior = computed(function () {
      return smooth.value ? 'smooth' : 'auto';
    });
    var _useScroll = useScroll(el, {
        behavior: behavior
      }),
      y = _useScroll.y;
    var lastAccessRoute = ref('');
    var routes = computed(function () {
      var menus = [];
      var allroutes = _.filter(router.options.routes, function (item) {
        return !_.includes([ROUTE_NAME.HOME], item.name);
      });
      _.each(allroutes, function (item) {
        if (item.children && _.size(item.children)) {
          _.each(item.children, function (child) {
            return menus.push(child);
          });
        } else menus.push(item);
      });
      return menus;
    });
    function onScroll(state) {
      localCache.setItem('Yhome', state.y.value);
    }
    onMounted(function () {
      lastAccessRoute.value = localCache.getItem('lastAccessRoute');
      nextTick(function () {
        return y.value = localCache.getItem('Yhome');
      });
    });
    return function (_ctx, _cache) {
      var _component_van_cell = _resolveComponent("van-cell");
      var _component_van_cell_group = _resolveComponent("van-cell-group");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "home-page",
        ref_key: "el",
        ref: el
      }, [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), function (item, index) {
            return _openBlock(), _createBlock(_component_van_cell, {
              key: index,
              replace: "",
              "is-link": "",
              title: "".concat(index + 1, "\u3001").concat(item.meta.title),
              to: {
                name: item.name
              },
              class: _normalizeClass(item.name === _unref(lastAccessRoute) || item.children && item.children.map(function (ele) {
                return ele.name;
              }).includes(_unref(lastAccessRoute)) ? 'activated' : null)
            }, null, 8, ["title", "to", "class"]);
          }), 128))];
        }),
        _: 1
      })])), [[_unref(vScroll), onScroll]]);
    };
  }
});